import axiosInstance from "../../apiAxios/axiosInstance";


export const loginAdmin = async (loginData) => {
  const response = await axiosInstance.post("/admin-login", loginData);
  return response.data;
};

export const getAdminProfile = async () => {
  const response = await axiosInstance.get("/admin/admin-profile");
  return response;
};


export const getDashboardCounts = async () => {
  const response = await axiosInstance.get("/admin/admin-dashboard-count-list");
  return response.data;
};


export const changeAdminPassword = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/admin-change-password",
    payload
  );
  return response.data;
};
export const logoutAdmin = async () => {
  const response = await axiosInstance.post("/admin/admin-logout");
  return response.data;
};

// export const getStaffPermissions = async (staffId) => {
//   const response = await axiosInstance.post(
//     "/admin/staff-permissions",
//     {
//       id: staffId,
//     }
//   );

//   return response.data;
// };
export const getStaffPermissions = async (id) => {
  const response = await axiosInstance.post("/admin/staff-permissions", {
    id,
  });

  return response.data;
};